import { gql } from '@apollo/client';

const GET_CLASSROOM = gql`
  query getClassroom($classroomWhere: ClassroomWhereInput!) {
    classroom(where: $classroomWhere) {
      id
      name
      color
      studentCount
      students {
        id
        username
        firstName
        lastName
        gradeLevel
      }
      licenseUsage {
        productCurriculum {
          id
          name
          gradeLevel
        }
        productCurriculumId
        productId
      }
    }
  }
`;

export default GET_CLASSROOM;
